import React, { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls, Icosahedron, Float, Stars } from '@react-three/drei'
import * as THREE from 'three'

const SceneContent = ({
  primaryColor = '#1da094',
  secondaryColor = '#115e59',
  tertiaryColor = '#5eead4',
}) => {
  const meshRef = useRef()

  useFrame((state) => {
    const time = state.clock.getElapsedTime()
    if (meshRef.current) {
      meshRef.current.rotation.y = time * 0.1
      meshRef.current.rotation.x = Math.sin(time * 0.2) * 0.1
    }
  })

  return (
    <>
      <Float speed={2} rotationIntensity={0.5} floatIntensity={0.5}>
        <group ref={meshRef}>
          {/* Wireframe Network */}
          <Icosahedron args={[2.2, 1]}>
            <meshBasicMaterial
              color={primaryColor}
              wireframe
              transparent
              opacity={0.3}
            />
          </Icosahedron>

          {/* Inner Glow Core */}
          <Icosahedron args={[2, 0]}>
            <meshBasicMaterial
              color={secondaryColor}
              transparent
              opacity={0.05}
              blending={THREE.AdditiveBlending}
            />
          </Icosahedron>

          {/* Solid Dark Background */}
          <Icosahedron args={[2.2, 1]}>
            <meshBasicMaterial
              color={secondaryColor}
              transparent
              opacity={0.3}
            />
          </Icosahedron>

          {/* Points at vertices */}
          <points>
            <icosahedronGeometry args={[2.2, 1]} />
            <pointsMaterial
              size={0.08}
              color={tertiaryColor}
              transparent
              opacity={0.8}
              sizeAttenuation
            />
          </points>
        </group>
      </Float>

      {/* Background Particles */}
      <Stars
        radius={50}
        depth={50}
        count={1000}
        factor={4}
        saturation={0}
        fade
        speed={1}
      />
    </>
  )
}

export default function SubBrokerScene({
  primaryColor = '#1da094',
  secondaryColor = '#115e59',
  tertiaryColor = '#5eead4',
}) {
  return (
    <div style={{ width: '100%', height: '100%', minHeight: '400px' }}>
      <Canvas camera={{ position: [0, 0, 6], fov: 45 }} dpr={[1, 2]}>
        <ambientLight intensity={0.5} />
        <pointLight
          position={[10, 10, 10]}
          intensity={1}
          color={primaryColor}
        />
        <SceneContent
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          tertiaryColor={tertiaryColor}
        />
        <OrbitControls
          enableZoom={false}
          enablePan={false}
          autoRotate
          autoRotateSpeed={0.5}
        />
      </Canvas>
    </div>
  )
}
